/* eslint-disable camelcase */
import ufeApi from 'services/api/ufeApi';
import { appendSotTrackingIdHeader } from 'ai/utils/getSotTrackingId';

const URL = '/gway/v1/genai-pa-manager/session';

const managerSession = (token, sessionFound, ecid) => {
    const headers = {
        'Content-Type': 'application/json',
        authorization: `Bearer ${token}`
    };

    if (sessionFound) {
        return new Promise(resolve => {
            resolve({
                genai_pa_session_id: sessionFound,
                token: token
            });
        });
    }

    const params = new URLSearchParams();

    if (ecid) {
        params.append('ecid', ecid);
    }

    const sotTrackingId = appendSotTrackingIdHeader(headers);

    if (sotTrackingId) {
        params.append('sot_tracking_id', sotTrackingId);
    }

    const queryString = params.toString();
    const url = queryString ? `${URL}?${queryString}` : URL;

    return ufeApi
        .makeRequest(url, {
            method: 'POST',
            headers
        })
        .then(data => (data.errorCode ? Promise.reject(data) : { ...data, token: token }));
};

export default managerSession;
